import { useSEO } from '../../utils/seo';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import VideoGallery from './components/VideoGallery';
import ImportantInfo from './components/ImportantInfo';
import MeetingForm from './components/MeetingForm';
import Contact from './components/Contact';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Consultadoria de Serviços em Saúde - Implementação e Gestão de Unidades de Saúde',
    description: 'Consultadoria especializada em serviços de saúde. Apoiamos clínicas, hospitais e profissionais na criação, legalização e gestão eficiente de unidades de saúde. Implementação chave-na-mão, projetos de arquitetura, formação de equipas e suporte jurídico personalizado em Portugal.',
    keywords: 'consultadoria saúde, serviços saúde, implementação clínicas, legalização hospitais, gestão unidades saúde',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'Consultadoria de Serviços em Saúde',
      description: 'Consultadoria especializada em serviços de saúde. Apoiamos clínicas, hospitais e profissionais na criação, legalização e gestão eficiente de unidades de saúde.',
      url: siteUrl,
      telephone: '+351912345678',
      email: 'consultadoriaeservicosemsaude@gmail.com',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'PT'
      },
      areaServed: {
        '@type': 'Country',
        name: 'Portugal'
      },
      serviceType: [
        'Consultadoria em Saúde',
        'Implementação de Clínicas',
        'Legalização de Unidades de Saúde',
        'Gestão de Unidades de Saúde',
        'Projetos de Arquitetura para Saúde',
        'Formação de Equipas Médicas'
      ],
      priceRange: '€€€',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '50'
      }
    }
  });

  return (
    <>
      <Hero />
      <About />
      <Services />
      <VideoGallery />
      <ImportantInfo />
      <MeetingForm />
      <Contact />
    </>
  );
}